document.addEventListener("DOMContentLoaded", function () {

    // Create properties object with box contents
    // Define excluded item IDs
    let excludedPropertyItemIds = [
        54332608807238,
        14972186624326,
        54572211110214,
        54572211142982,
        54572211175750,
        54365882810694, // Pink plush
        54365879042374, // Blue plush
    ];


    const giftItemSection = document.getElementById('gift-item-section');
    giftItemSection.style.display = 'none';

    function renderBundleFooterMessage(productCount) {
        const { productCount: pc, currentTier: ct, nextTier: nt, itemsNeeded: need } =
            getBundleState(productCount);

        const footer = document.querySelector(".bundles-bar-footer");
        if (!footer) return;

        const footerMsgEl =
            footer.querySelector(".js-bundle-message") || footer;

        const box = n => `box${n === 1 ? "" : "es"}`;

        let footerHTML = "";
        switch (pc) {
            case 0:
            footerHTML = `Choose a box of truffles to start building your bundle`; break;
            case 1:
            footerHTML = `Choose <strong>2</strong> more boxes of truffles to complete your <strong>3</strong> box bundle`; break;
            case 2:
            footerHTML = `Choose <strong>1</strong> more box of truffles to complete your <strong>3</strong> box bundle`; break;
            case 3:
            footerHTML = `Your <strong>3</strong> box bundle is complete! Double your truffles & add <strong>3</strong> more boxes to save <strong>30%</strong>`; break;
            case 4:
            footerHTML = `Choose <strong>2</strong> more boxes of truffles to complete your <strong>6</strong> box bundle & save <strong>30%</strong>`; break;
            case 5:
            footerHTML = `Choose <strong>1</strong> more box of truffles to complete your <strong>6</strong> box bundle & save <strong>30%</strong>`; break;
            case 6:
            footerHTML = `Your <strong>6</strong> box bundle is complete! Get the best value & add <strong>3</strong> more boxes to save <strong>40%</strong>`; break;
            case 7:
            footerHTML = `Choose <strong>2</strong> more boxes of truffles to complete your <strong>9</strong> box bundle & save <strong>40%</strong>`; break;
            case 8:
            footerHTML = `Choose <strong>1</strong> more box of truffles to complete your <strong>9</strong> box bundle & save <strong>40%</strong>`; break;
            case 9:
            footerHTML = `You've hit the sweet spot - your <strong>9</strong> box bundle is complete!`; break;
            default:
            footerHTML = pc > MAX_SLOTS
                ? `You’ve exceeded ${MAX_SLOTS} items — review your bundle or proceed to checkout.`
                : `Add <strong>${need}</strong> more ${box(need)} to reach <strong>${nt}</strong> ${box(nt)}.`;
        }

        footerMsgEl.innerHTML = footerHTML;
        footer.classList.remove("is-waiting-for-js"); // optional, see tip #4
    }


    // Gift card button click
    const giftCardButtons = document.querySelectorAll('.gift-card-button.gift');
    const giftCardButton = document.querySelector('.gift-card-button');
    const modalOverlay = document.querySelector('.modal-overlay');
    const closeButton = document.querySelector('.close-btn');
    const addCardButton = document.querySelector('#add-card');
    const messageTextarea = document.querySelector('.message-section textarea');
    const imagePlaceholder = document.querySelector('.image-placeholder');
    const giftCardCircle = document.querySelector('li.gift-card-button');
    const imageUrl = null;
    let bundleId = getOrMakeBundleId();
  
    
    giftCardButton.addEventListener('click', () => {
        modalOverlay.style.display = 'flex';
    });

    closeButton.addEventListener('click', () => {
        modalOverlay.style.display = 'none';
    });

    // Click background to remove modal
    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
            modalOverlay.style.display = 'none';
        }
    });

    // Add/keep this somewhere shared
    function getOrMakeBundleId(providedId) {
        if (providedId) return String(providedId);
        const key = "bundleId";
        // let id = sessionStorage.getItem(key);

        //if (!id) {
            // cryptographically-strong 6-digit string "000000"–"999999"
            const buf = new Uint32Array(1);
            crypto.getRandomValues(buf);
            id = String(buf[0] % 1_000_000).padStart(6, "0");

            // If you prefer a prefix, uncomment:
            // id = `bndl_${id}`;

            //sessionStorage.setItem(key, id);
        //}

        return id;
    }

  function openGiftCardModal(button) {

    // const product = {
    //   variants: [
    //     { id: 123, title: "Small / Red", available: true },
    //     { id: 124, title: "Medium / Blue", available: false },
    //     { id: 125, title: "Large / Green", available: true }
    //   ]
    // };
    
    // // Get the select element
    // const select = document.getElementById('variant-select');
    
    // // Add default empty option
    // const defaultOption = document.createElement('option');
    // defaultOption.value = '';
    // defaultOption.textContent = 'Select a variant';
    // select.appendChild(defaultOption);
    
    // // Filter and loop through in-stock variants only
    // product.variants
    //   .filter(variant => variant.available) // Only include variants where available is true
    //   .forEach(variant => {
    //     const option = document.createElement('option');
    //     option.value = variant.id;
    //     option.textContent = variant.title;
    //     select.appendChild(option);
    //   });

    // END OF NEW MODAL SETTINGS
    
    // Get the image URL from the data attribute
    const imageUrl = button.dataset.imageUrl;
    this.imageUrl = imageUrl;
    //alert(imageUrl)
    
    // Update modal image
    // if (imageUrl) {
    //     imagePlaceholder.innerHTML = '';
    //     const modalImage = document.createElement('img');
    //     modalImage.src = imageUrl;
    //     modalImage.alt = 'Gift card image';
    //     modalImage.style.maxWidth = '100%';
    //     imagePlaceholder.appendChild(modalImage);
    // } else {
    //     // Fallback if no data attribute
    //     imagePlaceholder.innerHTML = '<p>Image of card design</p>';
    // }

    modalOverlay.style.display = 'flex';

    
    addCardButton.addEventListener('click', (e) => {
      addGiftCard(e);
    });


    // let cart = {
    //     items: [],
    //     addGiftCard(message) {
    //         this.items.push({
    //             type: 'gift-card',
    //             message: message,
    //             dateAdded: new Date()
    //         });
    //         console.log('Cart updated:', this.items); // For debugging
    //     }
    // };
  }


    function addGiftCard(e) {
        e.preventDefault(); // Prevent form submission if in a form
        
        const message = messageTextarea.value.trim();

        let retrievedCard = JSON.parse(localStorage.getItem('card'));


        
        // if (message) {
            // Add to Shopify cart
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        quantity: 1,
                        id: retrievedCard, // Replace with your actual gift card variant ID
                        properties: {
                            'Message': message, // This will show in the cart and order
                            'belongs to bundle': bundleId
                        }
                    }]
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Added to Shopify cart:', data);
                modalOverlay.style.display = 'none';
                messageTextarea.value = '';
              
                const imageUrl = giftCardCircle.dataset.imageUrl;
                giftCardCircle.innerHtml = 'Card added';
                updateBundleBar();
                //alert('Gift card added to cart!');
                // Optionally update cart display (e.g., cart count)
                // document.querySelector('.cart-count').textContent = data.items.length;

            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                alert('You already have a card in your cart');
            });
        // } else {
        //     alert('Please enter a message for your gift card');
        // }


        // const filledGift = document.querySelector(".gift-filled");
        // const emptyGift = document.querySelector(".gift-empty");

        // console.log("set empty card element to hidden as we just added");
        // console.log("debug: filledGift =", filledGift, "is in DOM:", filledGift?.isConnected);
        // console.log("debug: emptyGift =", emptyGift, "is in DOM:", emptyGift?.isConnected);

        // if (filledGift && filledGift.isConnected) {
        //     filledGift.classList.remove('hidden'); // Show the element
        //     console.log("filledGift classes after update:", filledGift.className);
        // } else {
        //     console.warn("filledGift is null or not in DOM");
        // }

        // if (emptyGift && emptyGift.isConnected) {
        //     emptyGift.classList.add('hidden'); // Hide the element
        //     console.log("emptyGift classes after update:", emptyGift.className);
        // } else {
        //     console.warn("emptyGift is null or not in DOM");
        // }

        // console.log("after ====");
        // console.log("filledGift in DOM:", filledGift, document.body.contains(filledGift));
        // console.log("emptyGift in DOM:", emptyGift, document.body.contains(emptyGift));

        // // Force a DOM reflow to ensure rendering
        // document.body.offsetHeight; // Trigger reflow
       
    }

  
    // Attach the open/close toggle listener
    function attachBundleToggle() {
        const bundleWrapper = document.querySelector(".bundles-bar-wrapper");
        const bundleHeader = document.querySelector(".bundles-bar-header");

        if (!bundleWrapper || !bundleHeader) return;

        // Remove any previous event listeners before reattaching
        bundleHeader.replaceWith(bundleHeader.cloneNode(true));
        const newBundleHeader = document.querySelector(".bundles-bar-header");
        const addToBundleButton = document.querySelector(".quick-add__submit");

        // Attach a fresh event listener
        newBundleHeader.addEventListener("click", function () {
            bundleWrapper.classList.toggle("active");
            console.log("Bundle bar toggled. Active state:", bundleWrapper.classList.contains("active"));
        });

        // Attach on first product add
        addToBundleButton.addEventListener("click", function () {
            newBundleHeader.classList.toggle("active");
            console.log("Bundle bar toggled. Active state:", bundleWrapper.classList.contains("active"));
        });

        console.log("Bundle toggle event attached!");
    }

    // Attach event listener for remove buttons
    function attachRemoveListeners() {
        document.querySelectorAll(".js-bundle-remove-btn").forEach(btn => {
            btn.addEventListener("click", function () {
                const productId = this.getAttribute("data-product-id");
                console.log("REMOVE BUTTON CLICKED", productId);
                removeFromCart(productId);
            });
        });
        document.querySelectorAll("#card-remove").forEach(btn => {
            btn.addEventListener("click", function () {
                const productId = this.getAttribute("data-product-id");
                console.log("REMOVE BUTTON CLICKED", productId);
                localStorage.removeItem('card');
                removeFromCart(productId);
                updateBundleBar();
            });
        });
    }

    // function attachCheckoutListener() {
    //   document.querySelectorAll(".js-bundle-remove-btn").forEach(btn => {
    //       btn.addEventListener("click", function () {
    //           const productId = this.getAttribute("data-product-id");
    //           console.log("REMOVE BUTTON CLICKED", productId);
    //           removeFromCart(productId);
    //       });
    //   });
    // }

    // Disable or enable Add to Cart button based on cart count
    function updateAddToCartButton() {
        const addToCartButtons = document.querySelectorAll(".js-add-to-cart"); // Replace with actual button class
        const productCount = document.querySelectorAll(".bundles-list-ul .hasproduct").length;

        const giftCardButtons = document.querySelectorAll('.gift-card-button.gift');
        giftCardButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                console.log("gift card button clicked");
                openGiftCardModal(btn);
            });
        });

        if (productCount > 9 || productCount == 0) {
            addToCartButtons.forEach(button => {
                button.setAttribute("disabled", "disabled");
            });
            console.log("Add to Cart button disabled: Max bundle reached.");
        } else {
            addToCartButtons.forEach(button => {
                if(productCount == 3 || productCount == 6 || productCount == 9) {
                  button.removeAttribute("disabled");
                  button.classList.remove("disabled");
                  console.log("disable removed")
                  enableButtonForClicking();
                  console.log("Add to Cart button enabled.");
                }
            });
            
        }
    }

    function enableButtonForClicking() {
      console.log("enableButtonForClicking")
      const checkoutBundleButton = document.querySelector('.checkout-btn');
      checkoutBundleButton.addEventListener('click', (e) => {
        console.log("checkoutBundleButton in enableButtonForClicking log")
        e.preventDefault(); // Prevent form submission if in a form
        clickCheckout();
      });
    }

    function initializeBundleBar() {
        const bundleList = document.querySelector(".bundles-list-ul");

        if (!bundleList) return;

        localStorage.removeItem('card');

        // Count how many products are already in the cart
        let productCount = bundleList.querySelectorAll(".hasproduct").length;

        // Check for card
        // const giftCardCircle = document.querySelector('.gift-filled');
        // const imageUrl = giftCardCircle.dataset.imageUrl;
        // giftCardCircle.innerHtml = '<img src="' + imageUrl + '" alt="">'

        console.log("INITIAL COUNT: ", productCount);

        // Calculate remaining slots needed to make a total of 9
        let emptySlots = 9 - productCount;

        console.log("INITIAL EMPTY COUNT: ", emptySlots);

        // Ensure we remove any extra empty slots before adding new ones
        bundleList.querySelectorAll(".hasnoproduct").forEach(el => el.remove());

        // Append empty <li>'s if needed
        for (let i = 0; i < emptySlots; i++) {
            let emptyLi = document.createElement("li");
            emptyLi.classList.add("hasnoproduct");
            bundleList.appendChild(emptyLi);
        }

        // Determine the current bundle tier
        let currentTier = productCount >= 9 ? 9 : productCount >= 6 ? 6 : productCount >= 3 ? 3 : 0;

        // Determine the next bundle tier
        let nextTier = productCount < 3 ? 3 : productCount < 6 ? 6 : productCount < 9 ? 9 : 9;

        console.log("INITIAL CURRENT TIER:", currentTier);
        console.log("INITIAL NEXT TIER:", nextTier);

        // Calculate how many more items are needed
        let itemsNeeded = nextTier - productCount;

        if (productCount === currentTier) {
            itemsNeeded = 0;
        }

        // **FIX: Check if elements exist before updating them**
        const bundleCount = document.querySelector(".js-bundle-count");
        const bundleCount2 = document.querySelector(".js-bundle-count2");

        if (bundleCount) {
            bundleCount.textContent = itemsNeeded;
        }
        if (bundleCount2) {
            bundleCount2.textContent = (![3, 6, 9].includes(productCount)) ? nextTier : currentTier;
        }

        giftCardButton.addEventListener('click', (e) => {
          console.log("gift card button clicked")
          openGiftCardModal();
        });

        // if (localStorage.getItem('card') == null) {
        //     const filledGift = document.querySelector(".gift-filled");
        //     const emptyGift = document.querySelector(".gift-empty");
            
        //         console.log("card isnt set")
        //         if(filledGift) {
        //             filledGift.style.display = 'none';
        //         }

        //         if(emptyGift) {
        //             emptyGift.style.display = 'flex';
        //         }
            
        // } else {
        //     const filledGift = document.querySelector(".gift-filled");
        //     const emptyGift = document.querySelector(".gift-empty");
            
        //          if(filledGift) {
        //             filledGift.style.display = 'flex';
        //         }

        //         if(emptyGift) {
        //             emptyGift.style.display = 'none';
        //         }
            
        // }


        renderBundleFooterMessage(productCount);

        updateAddToCartButton();
        attachBundleToggle();
        attachRemoveListeners();
    }


    // Remove an item from the cart
    function removeFromCart(productId) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let cartItem = cart.items.find(item => item.variant_id == productId);
                let cardItem = cart.items.find(item => item.id == "54332608807238");

                if (!cartItem) return;

                let newQuantity = cartItem.quantity - 1;

                if(cardItem?.length > 0) {
                  newQuantity = cartItem.quantity - 2;
                }

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: productId, quantity: newQuantity })
                })
                    .then(response => response.json())
                    .then(() => {
                        updateBundleBar();
                        updateAddToCartButton(); // Update Add to Cart after removing
                    })
                    .catch(error => console.error("Error updating cart:", error));
            })
            .catch(error => console.error("Error fetching cart:", error));
    }

    const MAX_SLOTS = 9;
    const TIERS = [3, 6, 9];

    function getBundleState(productCount) {
    const currentTier = productCount >= 9 ? 9
                        : productCount >= 6 ? 6
                        : productCount >= 3 ? 3
                        : 0;

    const nextTier = productCount < 3 ? 3
                    : productCount < 6 ? 6
                    : productCount < 9 ? 9
                    : 9;

    let itemsNeeded = nextTier - productCount;
    if (productCount === currentTier) itemsNeeded = 0;

    return { productCount, currentTier, nextTier, itemsNeeded };
    }


    function updateBundleBar() {
        fetch(`${window.location.pathname}?sections=bundlebar`)
            .then(response => response.json())
            .then(data => {
                const bundleWrapper = document.querySelector(".bundles-bar-wrapper");
                if (!bundleWrapper || !data["bundlebar"]) return;

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = data["bundlebar"];

                const newContent = tempDiv.querySelector(".bundles-bar-content");
                const newFooter = tempDiv.querySelector(".bundles-bar-footer");

                if (newContent && newFooter) {
                    document.querySelector(".bundles-bar-content").innerHTML = newContent.innerHTML;
                    document.querySelector(".bundles-bar-footer").innerHTML = newFooter.innerHTML;

                    const bundleList = document.querySelector(".bundles-list-ul");
                    let productCount = bundleList.querySelectorAll(".hasproduct").length;
                    let emptySlots = 9 - productCount;

                    bundleList.querySelectorAll(".hasnoproduct").forEach(el => el.remove());

                    bundleList.querySelectorAll(".hasnoproduct")
                    // Update card circle if card has been added
                    // const giftItem = document.querySelectorAll(".gift-item");
                    // if(giftItem) {
                    //   const gift = document.querySelector(".gift");
                    //   gift.textContent = "CARD ADDED";
                    //   giftItem.forEach(el => el.remove());
                    // }
                    

                    for (let i = 0; i < emptySlots; i++) {
                        let emptyLi = document.createElement("li");
                        emptyLi.classList.add("hasnoproduct");
                        bundleList.appendChild(emptyLi);
                    }

                    let currentTier = productCount >= 9 ? 9 : productCount >= 6 ? 6 : productCount >= 3 ? 3 : 0;
                    let nextTier = productCount < 3 ? 3 : productCount < 6 ? 6 : productCount < 9 ? 9 : 9;

                    let itemsNeeded = nextTier - productCount;
                    if (productCount === currentTier) itemsNeeded = 0;

                    // **FIX: Check if elements exist before updating them**
                    const bundleCount = document.querySelector(".js-bundle-count");
                    const bundleCount2 = document.querySelector(".js-bundle-count2");

                    if (bundleCount) {
                        bundleCount.textContent = itemsNeeded;
                    }
                    if (bundleCount2) {
                        bundleCount2.textContent = (![3, 6, 9].includes(productCount)) ? nextTier : currentTier;
                    }

                                        // Build a custom footer message for each case
                    const { productCount: pc, currentTier: ct, nextTier: nt, itemsNeeded: need } =
                    getBundleState(productCount);

                    const footerMsgEl =
                    document.querySelector(".bundles-bar-footer .js-bundle-message") ||
                    document.querySelector(".bundles-bar-footer");

                    // Utility for nice grammar
                    const box = n => `box${n === 1 ? "" : "es"}`;

                    renderBundleFooterMessage(productCount);

                    let retrievedCard = JSON.parse(localStorage.getItem('card'));
                    const addNoteButton = document.getElementById('add-note-button');
                    const giftItemSection = document.getElementById('gift-item-section');

    
                    // if card exists then show the card filled icon
                    if (retrievedCard) {
                        giftItemSection.style.display = 'flex';
                        addNoteButton.style.display = 'none';
                    } else {
                        giftItemSection.style.display = 'none';
                        addNoteButton.style.display = 'flex';
                    }

                    // if (footerMsgEl) {
                    // footerMsgEl.innerHTML = footerHTML;
                    // }

                    // Ensure add-to-cart button state is updated
                    updateAddToCartButton();
                }

                attachBundleToggle();
                attachRemoveListeners();
            })
            .catch(error => console.error("Error fetching updated bundle bar:", error));
    }

  

    const checkoutBundleButton = document.querySelector('.checkout-btn');
    let boxOfThree = '54371088793926'
    let boxOfSix = '54371088826694'
    let boxOfNine = '54371088859462'

    let excludedItemIds = [
        54371088793926, // Box items
        54371088826694,
        54371088859462,
        54332608807238, // Gift card
        54365882810694, // Pink plush
        54365879042374, // Blue plush
    ];

    // Retrieve card from localStorage
    
    
    function clickCheckout() {
      
    let retrievedCard = JSON.parse(localStorage.getItem('card'));
    
    // Add the card ID to excludedItemIds
    if (retrievedCard) {
        excludedItemIds.push(retrievedCard);
    }
      
    console.log("clickCheckout invoked")
    // Fetch the cart data from Shopify
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(cart => {
        // Count the total quantity of all items in the cart
        // const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
        let totalItems = 0;
        const properties = {};
        cart.items.forEach(item => {
            // Debug log to inspect properties
            console.log(`Item: ${item.title}, Properties:`, item.properties, `Has 'belongs to bundle':`, 'belongs to bundle' in item.properties);
            
            // Check if this item should be counted (not in the excluded list and no 'belongs to bundle' property)
            if (!excludedItemIds.includes(item.variant_id) && !('belongs to bundle' in item.properties)) {
                totalItems += item.quantity;
            }
            // Add 'belongs to bundle' property
            //properties[`belongs to bundle`] = `155`;
        });
        console.log(`Total items in cart: ${totalItems}`);
        console.log(cart.items);

        // Get the titles and quantities of all items in the cart
        const itemTitlesWithQuantity = cart.items.map(item => ` ${item.title} x${item.quantity}`);
        console.log(`Item titles with quantities: ${itemTitlesWithQuantity}`);

        let selectedBoxSize = null;
        if (totalItems === 3) {
            selectedBoxSize = boxOfThree;
        } else if (totalItems === 6) {
            selectedBoxSize = boxOfSix;
        } else if (totalItems === 9) {
            selectedBoxSize = boxOfNine;
        }

        // Only proceed if a valid box size is selected
        if (selectedBoxSize) {
          console.log('Starting cart items removal');
      
          // Collect information about current cart items before removal
          const itemsForProperties = cart.items.map(item => ({
              title: item.title,
              quantity: item.quantity,
              variant_id: item.variant_id,
              key: item.key
          }));
          
          

           
           let retrievedCard = JSON.parse(localStorage.getItem('card'));
    
            // Add the card ID to excludedItemIds
            if (retrievedCard) {
                excludedPropertyItemIds.push(retrievedCard);
            }
                  
          // Filter items first
          const filteredItemsForProperties = itemsForProperties.filter(item => 
              !excludedPropertyItemIds.includes(item.variant_id)
          );
          
          
          // Add each filtered item as a numbered property
          filteredItemsForProperties.forEach((item, index) => {
            if (!item.title.includes('Build Your Bundle')) {
              properties[`Item ${index + 1}`] = `${item.quantity}x ${item.title}`;
              console.log(`Adding to box properties: ${item.quantity}x ${item.title}`);
            }
          });
          
          // Add the filtered items as JSON string
          //properties['_Box Contents'] = JSON.stringify(filteredItemsForProperties);

          // Get card variant ID and message from localStorage
        //   const retrievedCardId = JSON.parse(localStorage.getItem('card'));
        //   const cardItem = cart.items.find(item => item.variant_id == retrievedCardId);
        //   const cardMessage = cardItem?.properties?.Message || '';
        //   const cardTitle = cardItem?.title || 'Card';
          
        //   // Append card info to the bundle
        //   if (cardItem) {
        //     filteredItemsForProperties.push({
        //       title: `${cardTitle} (Card)`,
        //       quantity: 1,
        //       message: cardMessage
        //     });
          
        //     const index = filteredItemsForProperties.length;
        //     properties[`Item ${index}`] = `1x ${cardTitle} (Card)`;
        //     properties['Card Message'] = cardMessage;
        //   }

        //localStorage.removeItem('card');

          
          // Method 1: Remove one by one sequentially
          async function processCart() {
              try {

                  
                  properties['belongs to bundle'] = bundleId;

                  // First, remove all items sequentially
                  const originalItems = [...cart.items]; // Make a copy of the items array
                  
                  for (let i = 0; i < originalItems.length; i++) {
                    const item = originalItems[i];

                    // Check if this item should be excluded from removal
                    if (excludedItemIds.includes(item.variant_id) || item.title.toLowerCase().includes('add card')) {
                        console.log(`Skipping removal of excluded item: ${item.title} (ID: ${item.variant_id})`);
                        continue; // Skip to the next item in the loop
                    }
                    
                    console.log(`Attempting to remove item: ${item.title} with key: ${item.key}`);
                    
                    try {
                        const response = await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                id: item.key, // Use the unique key which won't change
                                quantity: 0
                            })
                        });
                        
                        if (!response.ok) {
                            const errorData = await response.json();
                            console.error(`Error removing ${item.title}:`, errorData);
                            continue;
                        }
                        
                        const data = await response.json();
                        console.log(`Removed item ${item.title}:`, data);
                    } catch (error) {
                        console.error(`Error removing item ${item.title}:`, error);
                    }
                }

                // Remove card from cart if present
                //   if (retrievedCardId) {
                //     const cardInCart = cart.items.find(item => item.variant_id == retrievedCardId);
                //     if (cardInCart) {
                //       console.log(`Removing card: ${cardInCart.title}`);
                //       await fetch('/cart/change.js', {
                //         method: 'POST',
                //         headers: { 'Content-Type': 'application/json' },
                //         body: JSON.stringify({ id: cardInCart.key, quantity: 0 })
                //       });
                //     }
                //   }

                  
                  // Get final cart state after removals
                  const finalResponse = await fetch('/cart.js');
                  const updatedCart = await finalResponse.json();
                  const totalItemsAfterRemove = updatedCart.items.reduce((sum, item) => sum + item.quantity, 0);
                  console.log(`All items processed. Total items in cart after remove: ${totalItemsAfterRemove}`);
                  
                  // Now add the box with the properties
                  console.log('Adding box to cart with these properties:', properties);
                  const addResponse = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                          items: [{
                              quantity: 1,
                              id: selectedBoxSize, // Box variant ID
                              properties: properties
                          }]
                      })
                  });
                  
                  if (!addResponse.ok) {
                      const errorData = await addResponse.json();
                      console.error('Error adding box to cart:', errorData);
                      throw new Error(`Error ${addResponse.status}: ${JSON.stringify(errorData)}`);
                  }
                  
                  const addData = await addResponse.json();
                  console.log('Box product added to cart:', addData);
                  
                 // Redirect to cart or update the UI as needed
                 updateBundleBar();
                window.location.href = '/cart';
                  
              } catch (error) {
                  console.error('Error processing cart:', error);
              }
          }


            

            // Normalizes existing properties and sets/overwrites "belongs to bundle"
            function buildMergedProperties(item, bundleId, overwrite = false) {
                const existing = item.properties || {};
                const out = {};

                // Copy existing, dropping null/empty values (Shopify ignores empty)
                Object.keys(existing).forEach((k) => {
                    const v = existing[k];
                    if (v != null && String(v).trim() !== "") out[k] = v;
                });

                // Determine if it already has the property
                const hasAlready = Object.keys(out).some((k) => k.toLowerCase().trim() === "belongs to bundle");
                if (!hasAlready || overwrite) {
                    out["belongs to bundle"] = String(bundleId);
                }

            return out;
            }

            async function tagLineWithBundle(item, bundleId, overwrite = false) {
                const properties = buildMergedProperties(item, bundleId, overwrite);

                const res = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                    id: item.key,                  // line item key (stable)
                    quantity: item.quantity,       // keep quantity unchanged
                    properties,                    // merged properties incl. "belongs to bundle"
                    }),
                });

                if (!res.ok) {
                    let err;
                    try { err = await res.json(); } catch {}
                    throw new Error(`Failed to tag "${item.title}" (${item.key}): ${res.status} ${JSON.stringify(err || {})}`);
                }

                return res.json();
            }

            // // Call this instead of your previous (commented) flow
            // async function processCart({ bundleId, overwrite = false } = {}) {
            //     try {
            //         // 1) Get the latest cart
            //         const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
            //         const cart = await cartRes.json();

            //         // 2) Decide bundle id
            //         const idToUse = getOrMakeBundleId(bundleId);

            //         // 3) Tag each item sequentially (safer than blasting parallel writes)
            //         for (const item of cart.items) {
            //         // If you want to skip certain items, add a condition here:
            //         // if (excludedItemIds.includes(item.variant_id)) continue;

            //         await tagLineWithBundle(item, idToUse, overwrite);
            //         }

            //         // 4) Continue with your UI/redirect
            //         updateBundleBar?.();
            //         window.location.href = "/checkout";
            //     } catch (e) {
            //         console.error("Error tagging cart items with bundle id:", e);
            //     }
            // }

          
          // Alternative approach using cart/clear.js
          async function clearAndAddNewItem() {
              try {
                  // Clear the entire cart
                  const clearResponse = await fetch('/cart/clear.js', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      }
                  });
                  
                  if (!clearResponse.ok) {
                      const errorData = await clearResponse.json();
                      console.error('Error clearing cart:', errorData);
                      throw new Error(`Error ${clearResponse.status}: ${JSON.stringify(errorData)}`);
                  }
                  
                  console.log('Cart cleared successfully');
                  
                  // Add the box with properties
                  // const addResponse = await fetch('/cart/add.js', {
                  //     method: 'POST',
                  //     headers: {
                  //         'Content-Type': 'application/json'
                  //     },
                  //     body: JSON.stringify({
                  //         items: [{
                  //             quantity: 1,
                  //             id: selectedBoxSize,
                  //             properties: properties
                  //         }]
                  //     })
                  // });
                  
                  // if (!addResponse.ok) {
                  //     const errorData = await addResponse.json();
                  //     console.error('Error adding box to cart:', errorData);
                  //     throw new Error(`Error ${addResponse.status}: ${JSON.stringify(errorData)}`);
                  // }
                  
                  // const addData = await addResponse.json();
                  // console.log('Box product added to cart:', addData);
                  
              } catch (error) {
                  console.error('Error processing cart:', error);
              }
          }
          
          // Choose which method to use - sequential or clear all at once
          processCart();
          
      } else {
          console.log('No valid box size selected for the cart item count.');
      }
    })
    .catch(error => {
        console.error('Error fetching cart:', error);
    });
}


    // document.body.addEventListener("submit", function (event) {
    //     if (event.target.matches("form[action*='/cart/add']")) {
    //         event.preventDefault();
    //         console.log("ADD TO CART CLICKED");
    //         let formData = new FormData(event.target);

    //       // Ensure the variant ID is included
    //       //formData.append("id", "54371088793926"); //This adds the 'build your bundle product'
  
    //       // Log form data for debugging (optional)
    //       for (let [key, value] of formData.entries()) {
    //           console.log(`${key}: ${value}`);
    //       }

    //         fetch('/cart/add.js', {
    //             method: 'POST',
    //             body: formData
    //         })
    //             .then(response => response.json())
    //             .then(() => {
    //                 updateBundleBar();
    //                 updateAddToCartButton(); // Update button after adding
    //             })
    //             .catch(error => console.error("Error adding to cart:", error));
    //     }
    // });

    // Replace the generic form handler with specific button tracking
let isAddingToCart = false;

document.addEventListener('click', function(e) {
    const addToBundleBtn = e.target.closest('.quick-add__submit, .js-add-to-cart');
    
    if (addToBundleBtn && !isAddingToCart) {
        e.preventDefault();
        isAddingToCart = true;
        
        const form = addToBundleBtn.closest('form[action*="/cart/add"]');
        if (!form) {
            isAddingToCart = false;
            return;
        }
        
        console.log("ADD TO CART CLICKED - Processing");
        let formData = new FormData(form);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(() => {
            updateBundleBar();
            updateAddToCartButton();
        })
        .catch(error => console.error("Error adding to cart:", error))
        .finally(() => {
            isAddingToCart = false;
        });
    }
});

    initializeBundleBar();
});